import { render, staticRenderFns } from "./LiteEmbedInstructions.vue?vue&type=template&id=5423b626&"
import script from "./LiteEmbedInstructions.vue?vue&type=script&lang=js&"
export * from "./LiteEmbedInstructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports